import { Residence } from '@core/models/residence';

export class Config {

	network: string;
	residence: Residence;
	displayTimestamp: boolean;
}
